import React from 'react';
import classNames from 'classnames';
import {
  Text,
} from '@fluentui/react-components';

import { useStyles } from '../styles/no-data';

export function NoData({ i18n, showErrorText } : {
  i18n: { getString: (key: string) => string },
  showErrorText?: boolean,
}) {
  const classes = useStyles();
  return (
    <div className={classNames('ba-pc-no-data', classes.container)}>
      <div>
        {showErrorText &&
          <Text className="ba-pc-error-text" underline>{i18n.getString(_TL_('There has been an error retrieving data for this chart. Try refreshing the page.'))}</Text>
        }
        {!showErrorText &&
          <>
            <Text className="ba-pc-no-data-text" weight="bold" underline>{i18n.getString(_TL_('No data available.'))}</Text>
            <Text className="ba-pc-no-data-text2" underline>{i18n.getString(_TL_('To update the graph, select a different date range. If the graph remains blank, your account might have no data.'))}</Text>
          </>
        }
      </div>
    </div>
  );
}

NoData.defaultProps = {
  showErrorText: false,
};
